module.exports = __webpack_public_path__ + "img/sz.a637d912.png";